import type { BotMenu } from "@velizhanin-dev/bot-scenario"
import * as api from "@/entities/bot-builder"
import { draftCache as cache } from "@/entities/bot-builder"
import type { ActionsContext } from "./types"

export function createTagActions({ enqueue, scenarioId }: ActionsContext) {
	return {
		createTag: (name: string) =>
			enqueue(
				"Не удалось создать группу",
				(baseRevision) => api.createTag(scenarioId, { baseRevision, name }),
				(draft, result) => cache.upsertTag(draft, result.tag),
			),

		renameTag: (tagId: string, name: string) =>
			enqueue(
				"Не удалось переименовать группу",
				(baseRevision) => api.updateTag(scenarioId, tagId, { baseRevision, name }),
				(draft, result) => cache.upsertTag(draft, result.tag),
			),

		setTagArchived: (tagId: string, archived: boolean) =>
			enqueue(
				archived ? "Не удалось убрать группу в архив" : "Не удалось вернуть группу из архива",
				(baseRevision) => api.updateTag(scenarioId, tagId, { baseRevision, archived }),
				(draft, result) => cache.upsertTag(draft, result.tag),
			),

		archiveTags: (tagIds: string[], archived: boolean) =>
			enqueue(
				archived ? "Не удалось убрать группы в архив" : "Не удалось вернуть группы из архива",
				(baseRevision) => api.archiveTags(scenarioId, { baseRevision, tagIds, archived }),
				(draft, result) => cache.setTagsArchived(draft, result.tagIds, result.archived),
			),

		deleteTag: (tagId: string) =>
			enqueue(
				"Не удалось удалить группу",
				(baseRevision) => api.deleteTag(scenarioId, tagId, baseRevision),
				(draft) => cache.removeTag(draft, tagId),
			),

		saveMenu: (menu: BotMenu | null) =>
			enqueue(
				"Не удалось сохранить главное меню",
				(baseRevision) => api.putMenu(scenarioId, { baseRevision, menu }),
				(draft, result) => cache.setMenu(draft, result.menu),
			),
	}
}
